import axios from "axios";
import { API_BASE_URL } from "../../../config";

function authHeaders() {
  const token = localStorage.getItem("adminToken");
  return { Authorization: `Bearer ${token}` };
}

export async function fetchAdminLeagueDesk({
  page = 1,
  limit = 25,
  status = "all",
  seasonPhase = "all",
  search = "",
} = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (status && status !== "all") params.set("status", status);
  if (seasonPhase && seasonPhase !== "all") params.set("seasonPhase", seasonPhase);
  if (search) params.set("search", search);

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/leagues?${params.toString()}`,
    { headers: authHeaders() }
  );
  return data;
}

export async function fetchAdminLeagueDetail(leagueId) {
  const { data } = await axios.get(`${API_BASE_URL}/api/website/admin/leagues/${leagueId}`, {
    headers: authHeaders(),
  });
  return data;
}

export async function lookupAdminLeagues(q, limit = 10) {
  const params = new URLSearchParams();
  params.set("q", q);
  params.set("limit", String(limit));

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/leagues/lookup?${params.toString()}`,
    { headers: authHeaders() }
  );
  return data;
}

export async function addAdminLeague(body) {
  const { data } = await axios.post(`${API_BASE_URL}/api/website/admin/leagues`, body, {
    headers: authHeaders(),
  });
  return data;
}

export async function updateAdminLeague(leagueId, body) {
  const { data } = await axios.patch(
    `${API_BASE_URL}/api/website/admin/leagues/${leagueId}`,
    body,
    { headers: authHeaders() }
  );
  return data;
}

export async function syncAdminLeague(leagueId) {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/website/admin/leagues/${leagueId}/sync`,
    {},
    { headers: authHeaders() }
  );
  return data;
}

export async function syncAdminLeagueFixtures(leagueId, { window = "close" } = {}) {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/website/admin/leagues/${leagueId}/fixtures/sync`,
    { window },
    { headers: authHeaders() }
  );
  return data;
}

export async function fetchAdminLeagueFixtures(leagueId, { page = 1, limit = 20, scope = "upcoming" } = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  params.set("scope", scope);

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/leagues/${leagueId}/fixtures?${params.toString()}`,
    { headers: authHeaders() }
  );
  return data;
}

export async function syncAdminFixture(fixtureId) {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/website/admin/fixtures/${fixtureId}/sync`,
    {},
    { headers: authHeaders() }
  );
  return data;
}

export async function fetchAdminLeagueCandidates({
  page = 1,
  limit = 25,
  seasonPhase = "all",
  search = "",
} = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (seasonPhase && seasonPhase !== "all") params.set("seasonPhase", seasonPhase);
  if (search) params.set("search", search);

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/league-candidates?${params.toString()}`,
    { headers: authHeaders() }
  );
  return data;
}

export async function discoverAdminLeagueCandidates(limit = 20) {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/website/admin/league-candidates/discover`,
    { limit },
    { headers: authHeaders() }
  );
  return data;
}

export async function fetchAdminCandidateFixtures(
  candidateId,
  { page = 1, limit = 20, scope = "upcoming" } = {}
) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  params.set("scope", scope);

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/league-candidates/${candidateId}/fixtures?${params.toString()}`,
    { headers: authHeaders() }
  );
  return data;
}

export async function promoteAdminLeagueCandidate(candidateId, { isEnabled = true } = {}) {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/website/admin/league-candidates/${candidateId}/promote`,
    { isEnabled },
    { headers: authHeaders() }
  );
  return data;
}

export async function syncAdminCandidateFixtures(candidateId, { window = "close" } = {}) {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/website/admin/league-candidates/${candidateId}/fixtures/sync`,
    { window },
    { headers: authHeaders() }
  );
  return data;
}
